/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_radar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metric,Product A,Product B
Speed,80,60
Price,70,90`)
};

const es_radar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métrica,Producto A,Producto B
Velocidad,80,60
Precio,70,90`)
};

const de_radar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metric,Product A,Product B
Speed,80,60
Price,70,90`)
};

const nl_radar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metric,Product A,Product B
Snelheid,80,60
Prijs,70,90`)
};

const fr_radar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métrique,Produit A,Produit B
Vitesse,80,60
Prix,70,90`)
};

const it_radar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metrica,Prodotto A,Prodotto B
Velocità,80,60
Prezzo,70,90`)
};

const pt_br2_radar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métrica,Produto A,Produto B
Velocidade,80,60
Preço,70,90`)
};

const pt_radar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Métrica,Produto A,Produto B
Velocidade,80,60
Preço,70,90`)
};

const ja_radar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metric,Product A,Product B
Speed,80,60
Price,70,90`)
};

const zh_radar_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metric,Product A,Product B
Speed,80,60
Price,70,90`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const radar_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.radar_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("radar_placeholder", locale)
	if (locale === "en") return en_radar_placeholder(inputs)
	if (locale === "es") return es_radar_placeholder(inputs)
	if (locale === "de") return de_radar_placeholder(inputs)
	if (locale === "nl") return nl_radar_placeholder(inputs)
	if (locale === "fr") return fr_radar_placeholder(inputs)
	if (locale === "it") return it_radar_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_radar_placeholder(inputs)
	if (locale === "pt") return pt_radar_placeholder(inputs)
	if (locale === "ja") return ja_radar_placeholder(inputs)
	return zh_radar_placeholder(inputs)
};